import Marionette from "../../shared/marionette-mustache";
import { autoinject, Container, transient } from "aurelia-dependency-injection";
import { FullscreenReaderModel } from "../../desktop/models/fullscreen-reader";
import { backboneViewProperties } from "../../decorators/backbone-properties";
require("../styles/fullscreen-reader.less");

const template = require<string>("../../desktop/views/fullscreen-reader.html");

const dom = {
    CONTENT: ".full-text-content",
};

@backboneViewProperties({
    template
})
@autoinject
@transient()
export class FullscreenReaderView extends Marionette.LayoutView<FullscreenReaderModel> {

    constructor(public model: FullscreenReaderModel) {
        super();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        return events;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/fullscreen-reader.ts